class Message{
    constructor(json){
        this.message_id=json.message_id;
        this.title=json.title;
        this.body=json.body;
        this.status=json.status;
        this.created_at=json.created_at;
    }
}

export default Message;